export default __webpack_public_path__ + "static/media/logoWhite.10fab49d.png";